<app-grid
  #grid
  [columnDefs]="columnDefs"
  [rowData]="rowData"
  [rowSelection]="'multiple'"
  [useSelectAll]="useSelectAll"
  (onSelectedRowEvent)="onSelectedRowEvent($event)"
  (onSelectAllClicked)="onSelectedAllChanged()"
/>
